import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-import-validation',
  templateUrl: './import-validation.component.html',
  styleUrls: ['./import-validation.component.scss']
})
export class ImportValidationComponent {
  dataSource: any[] = [];
  displayedColumns: string[] = [];
  columnConfig: any[] = [];
  fileName = '';
  totalRows = 0;
  isValid = true;
  response: any;
  from = '';
  constructor(
    private dialogRef: MatDialogRef<ImportValidationComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit(): void {
    // Desestruturação para tornar o código mais limpo
    const { resp, file, from } = this.data;

    // Atribuições iniciais
    this.response = resp;
    this.fileName = file.name;
    this.from = from;
    this.isValid = resp.valido;

    // Usa uma única estrutura para definir a fonte de dados e as colunas
    if (this.isValid) {
      this.dataSource = this.response.registrosValidos;
      this.totalRows = this.dataSource.length;
      this.columnConfig = this.getColumnConfig(this.from);
    } else {
      this.dataSource = this.response.erros;
      this.totalRows = this.dataSource.length;
      this.columnConfig = this.getErrorColumnConfig();
    }

    this.displayedColumns = this.columnConfig.map(c => c.columnDef);
  }

  /**
   * Retorna a configuração de colunas com base na origem.
   * @param from A origem dos dados ('rodovia', 'parametro', 'servicos-iniciais').
   * @returns A configuração de colunas correspondente.
   */
  private getColumnConfig(from: string): any[] {
    // Usa um objeto para mapear a origem às configurações de coluna
    const configMap: { [key: string]: any[] } = {
      'rodovia': [
        { columnDef: 'numLinha', header: 'Número da linha', property: 'numLinha' },
        { columnDef: 'rodovia', header: 'Rodovia', property: 'rodovia' },
        { columnDef: 'descricao', header: 'Descrição', property: 'descricao' }
      ],
      'parametro': [
        { columnDef: 'numLinha', header: 'Número da linha', property: 'numLinha' },
        { columnDef: 'tipoDefeito', header: 'Tipo do Defeito', property: 'tipoDefeito' },
        { columnDef: 'tipoReparo', header: 'Tipo de Reparo', property: 'tipoReparo' },
        { columnDef: 'prazoAtendimento', header: 'Prazo de Atendimento', property: 'prazoAtendimento' },
        { columnDef: 'medida', header: 'Medida', property: 'medida' }
      ],
      'servicos-iniciais': [
        { columnDef: 'numeroContrato', header: 'Contrato', property: 'numeroContrato' },
        { columnDef: 'escopo', header: 'Escopo', property: 'escopo' },
        { columnDef: 'tipoServico', header: 'Tipo do serviço', property: 'tipoServico' },
        { columnDef: 'parametroDesempenho', header: 'Parâmetro', property: 'parametroDesempenho' },
        { columnDef: 'inicioPrazoAtendimento', header: 'Prazo de Atendimento (início)', property: 'inicioPrazoAtendimento' },
        { columnDef: 'medidaInicioPrazoAtendimento', header: 'Medida Prazo de atendimento (inicio)', property: 'medidaInicioPrazoAtendimento' },
        { columnDef: 'fimPrazoAtendimento', header: 'Prazo de atendimento (fim)', property: 'fimPrazoAtendimento' },
        { columnDef: 'medidaFimPrazoAtendimento', header: 'Medida Prazo de atendimento (fim)', property: 'medidaFimPrazoAtendimento' },
        { columnDef: 'valor', header: 'Valor', property: 'valor' },
        { columnDef: 'medidaValor', header: 'Medida Valor', property: 'medidaValor' }
      ],
    'servicos-ampliacao': [
      { columnDef: 'numeroContrato', header: 'Contrato', property: 'numeroContrato' },
      { columnDef: 'descricaoServico', header: 'Descrição do Serviço', property: 'descricaoServico' },
      { columnDef: 'rodovia', header: 'Rodovia', property: 'rodovia' },
      { columnDef: 'origemObra', header: 'Origem da Obra', property: 'origemObra' },
      { columnDef: 'tipoObra', header: 'Tipo da Obra', property: 'tipoObra' },
      { columnDef: 'kmInicial', header: 'KM Inicial', property: 'kmInicial' },
      { columnDef: 'kmFinal', header: 'KM Final', property: 'kmFinal' },
      { columnDef: 'valorObra', header: 'Valor da Obra', property: 'valorObra' },
      { columnDef: 'prazoVigenteInicial', header: 'Prazo Vigente (Início)', property: 'prazoVigenteInicial' },
      { columnDef: 'prazoVigenteFinal', header: 'Prazo Vigente (Fim)', property: 'prazoVigenteFinal' }
    ]
    };
    return configMap[from] || [];
  }

  /**
   * Retorna a configuração de colunas padrão para erros.
   * @returns A configuração de colunas para erros.
   */
  private getErrorColumnConfig(): any[] {
    return [
      { columnDef: 'numLinha', header: 'Número da linha', property: 'numLinha' },
      { columnDef: 'mensagem', header: 'Descrição de erro', property: 'mensagem' }
    ];
  }

  onImport() {
    this.dialogRef.close(true);
  }


  back() {
    this.dialogRef.close(false);
  }
  onReset() {
    this.dialogRef.close({ retry: true });
  }
}
